<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key"/>
    </transition>
  </section>
</template>

<script>

export default {
  name: "appMain",

  data() {
    return {}
  },
  computed: {
    key() {
      console.log(this.$route.fullPath, 'computed-app-main')
      return this.$route.fullPath
    }
  }
}
</script>

<style lang="scss">
.app-main{
    margin-top: 80px;
}
</style>
